import React, { useState, useEffect } from 'react';
import '../assets/css/Home.css';
import slider1 from '../assets/images/slider1.svg';
import slider2 from '../assets/images/slider2.svg';
import slider3 from '../assets/images/slider3.svg';
import animatedLearning from '../assets/images/animated-learning.svg';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      image: slider1,
      title: "Learn Oromo",
      description: "Begin your language journey"
    },
    {
      image: slider2,
      title: "Interactive Lessons",
      description: "Learn at your own pace"
    },
    {
      image: slider3,
      title: "Oromo Culture",
      description: "Discover rich traditions"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="home-page">
      {/* Hero Slider */}
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div 
            key={index} 
            className={`slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="slide-content">
              <h2>{slide.title}</h2>
              <p>{slide.description}</p>
              <a href="https://youtube.com/@teachoromoolanguagebydr.ab4564" target="_blank" rel="noopener noreferrer" className="btn-primary">Explore My YouTube channel</a>
            </div>
          </div>
        ))}
        
        <div className="slider-dots">
          {slides.map((_, index) => (
            <button 
              key={index} 
              className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Features Section */}
      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>Why Learn Afaan Oromo with Abdullah?</h2>
            <p> Discover the benefits of my unique learning approach. Learning Afaan Oromo with 
              Abdullah goes beyond memorising vocabulary—it’s about immersing yourself in the culture, context, 
              and everyday communication of millions of native speakers. Here’s what sets our method apart:</p>
          </div>

          <div className="features">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-laptop"></i>
              </div>
              <h3>Interactive Lessons</h3>
              <p>I am currently developing an interactive learning platform where I'm working on delivering interactive content to take your 
                learning to the next level—quizzes, dialogues, and activities to make learning fun and effective..</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>Community Support</h3>
              <p>Whether you're just starting out or looking to sharpen your Afaan Oromo skills, 
                my YouTube channel is here to support you every step of the way. With engaging lessons taught by Abdula—a passionate 
                native speaker—you’ll gain the confidence and tools you need to communicate effectively</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-book"></i>
              </div>
              <h3>Cultural Insights</h3>
              <p>In addition to language, we provide cultural insights that help you truly 
                connect with the Oromo community. You'll gain a deeper understanding of 
                traditions, values, and the way of life that shapes the language.o 
                language, we provide cultural insights that help you truly connect with the Oromo community. You'll gain a deeper understanding of traditions, values, and the way of life that shapes the language
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Animated Learning Section */}
      <section className="section">
        <div className="container">
          <div className="animated-section">
            <div className="animated-content">
              <h2>Modern Learning Techniques</h2>
              <p className="mobile-text">Unlock the power of the Afaan Oromo language with Abdula—right from your screen! Our lessons are designed for learners of all levels and delivered through engaging, easy-to-follow YouTube videos.</p>
              <p className="mobile-text">Access free, high-quality lessons on YouTube—perfect for busy schedules and flexible learning. We break down grammar, pronunciation, and vocabulary in a way that makes it easy to remember and apply.</p>
              <p className="mobile-text">With interactive exercises and real-world context, you'll learn Oromo faster than traditional methods. Whether you're a complete beginner or looking to improve your existing skills, our adaptive learning system will personalize your experience.</p>
              <div className="button-group mobile-centered">
                <a href="https://youtube.com/@teachoromoolanguagebydr.ab4564" target="_blank" rel="noopener noreferrer" className="btn-primary">Explore My YouTube channel</a>
              </div>
            </div>
            <div className="animated-image">
              <img src={animatedLearning} alt="Animated Learning" />
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section" style={{ backgroundColor: '#f0f4f8' }}>
        <div className="container">
          <div className="section-title">
            <h2>Ready to Start Your Journey?</h2>
            <a href="https://youtube.com/@teachoromoolanguagebydr.ab4564" target="_blank" rel="noopener noreferrer" className="btn-primary">Explore My YouTube channel</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;